// extracted by mini-css-extract-plugin
module.exports = {"SharePill":"Share-SharePill-24Iu7x","SharePillDark":"Share-SharePillDark-1o6tN0 Share-SharePill-24Iu7x"};